export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGOUT = "LOGOUT"

export const UPDATE_GAME = "UPDATE_GAME"

export const LOADING_START = "LOADING_START"
export const LOADING_STOP = "LOADING_STOP"
